"use client"
import Link from "next/link";
import Image from "next/image";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import { HeaderMobile } from '@/widget/header';
import { TickerList } from "@/features/ticker/ui"
import { HOME } from '@/shared/utils/const';
import { Inner } from '@/widget/container/ui/Inner';
//style
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';


export const HomePage = () => {
  return (
    <div className="mob-home-page">
      <HeaderMobile />
      {/*검색창 + tickerList*/}
      <div className="mob-home-scroll pc-scrollbar">
        <TickerList isTopRanking={true} />
        <Link href="/v2/market" className="flex items-center justify-center w-[calc(100%-21px)] h-[33px] mx-auto mt-[12px] mb-[8px] rounded-[50px] text-[14px] text-font-white border border-solid border-[rgba(255,255,255,0.28)]">
          View More
        </Link>
        {/*swiper slide*/}
        <Swiper
          modules={[Pagination]}
          spaceBetween={0}
          pagination={{ clickable: true }}
          slidesPerView={1}
          className="main"
        >
          <SwiperSlide className="py-[18px]  px-[16px]">
            <div className="relative flex items-center justify-between">
              <p className="text-[18px] font-semibold tracking-[-0.99px] text-font-basic">24시간 멈추지 않는 자동 매매,<br />스마트한 자산 운용의 시작</p>
              <Image src={HOME.mo.slide1} width={92} height={92} alt="slide" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="py-[18px]  px-[16px]">
            <div className="relative flex items-center justify-between">
              <p className="text-[18px] font-semibold tracking-[-0.99px] text-font-basic">설정만 하면 끝!<br />스마트한 자산 운용의 시작</p>
              <Image src={HOME.mo.slide2} width={92} height={92} alt="slide" />
            </div>
          </SwiperSlide>
          <SwiperSlide className="py-[18px]  px-[16px]">
            <div className="relative flex items-center justify-between">
              <p className="text-[18px] font-semibold tracking-[-0.99px] text-font-basic">AI가 고른 전략으로 자동매매 시작!<br />지금 바로 경험해보세요</p>
              <Image src={HOME.mo.slide3} width={92} height={92} alt="slide" />
            </div>
          </SwiperSlide>
        </Swiper>
        <dl className="mo-main-guide">
          <dt>이용 가이드</dt>
          <dd>
            <strong className=" text-font-basic font-semibold pl-[16px] text-[14px]">마틴게일(DCA) 이란?</strong>
            <Inner type="mobile" className="flex items-center justify-between pb-[16px]">
              <div className="w-[calc(100%-82px)]">
                <p>
                  한번쯤은 마틴게일 이란 단어를 접해 봤을
                  것입니다. 고전적인 마틴게일 전략은 한번의 게임에서 베팅금액을 잃으면 다음 회차에 2배로 베팅해 이길 확률을 높이는 전략입니다.
                </p>
                <Link href="https://super-trader.gitbook.io/super-trader/undefined/dca">
                  바로가기
                  <Image src={HOME.mo.link} width={14} height={14} alt="link" />
                </Link>
              </div>
              <div className="w-[58px] h-[58px] p-[10px]">
                <Image src={HOME.mo.guide1} width={38} height={38} alt="guide" />
              </div>
            </Inner>
          </dd>
          <dd className="pt-[16px]">
            <strong className="text-font-basic font-semibold pl-[16px]">DCA봇 추천 전략</strong>
            <Inner type="mobile" className="flex items-center justify-between pb-[16px]">
              <div className="w-[calc(100%-82px)]">
                <p>
                  SUPER TRADER는 초보 투자자를 위해 검증된 [추천 전략]을 제공하며, 사용자 커스터 마이징이 가능한 [간편 설정/상세 설정] 탭을 추가적으로 제공합니다.
                </p>
                <Link href="https://super-trader.gitbook.io/super-trader/undefined/dca/super-trader-dca-_-01">
                  바로가기
                  <Image src={HOME.mo.link} width={14} height={14} alt="link" />
                </Link>
              </div>
              <div className="w-[58px] h-[58px] p-[10px]">
                <Image src={HOME.mo.guide2} width={38} height={38} alt="guide" />
              </div>
            </Inner>
          </dd>
          <dd className="pt-[16px]">
            <strong className="text-font-basic font-semibold pl-[16px]">DCA봇 간편 설정</strong>
            <Inner type="mobile" className="flex items-center justify-between pb-[16px]">
              <div className="w-[calc(100%-82px)]">
                <p>
                  만약 추천 전략설정값을 수정하고 싶거나, 자신만의 설정으로 변경을 원한다면 [간편 설정]탭을 클릭하시면 됩니다. 추천전략화면에서 클릭시 설정값을 그대로 가져올수 있고, 다른 코인들을 선택하면 기본 Default 값으로 셋팅 됩니다.
                </p>
                <Link href="https://super-trader.gitbook.io/super-trader/undefined/dca/super-trader-dca-_-02">
                  바로가기
                  <Image src={HOME.mo.link} width={14} height={14} alt="link" />
                </Link>
              </div>
              <div className="w-[58px] h-[58px] p-[10px]">
                <Image src={HOME.mo.guide3} width={38} height={38} alt="guide" />
              </div>
            </Inner>
          </dd>
          <dd className="pt-[16px]">
            <strong className="text-font-basic font-semibold pl-[16px]">DCA봇 상세 설정</strong>
            <Inner type="mobile" className="flex items-center justify-between pb-[16px]">
              <div className="w-[calc(100%-82px)]">
                <p>[추천전략/간편설정]의 경우 주문 간격과 금액을 일정하게 설정해야 되지만, [상세 설정]의 경우, 회차별 간격과 금액을 조금더 디테일하게 설정을 할 수 있습니다.</p>
                <Link href="https://super-trader.gitbook.io/super-trader/undefined/dca/super-trader-dca-_-03">
                  바로가기
                  <Image src={HOME.mo.link} width={14} height={14} alt="link" />
                </Link>
              </div>
              <div className="w-[58px] h-[58px] p-[10px]">
                <Image src={HOME.mo.guide4} width={38} height={38} alt="guide" />
              </div>
            </Inner>
          </dd>
        </dl>
      </div>
    </div>
  )
}